<template>
  <div class="mx-0">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title>
          <v-icon color="secondary">content_copy</v-icon>
          <span></span>
          <span class="secondary--text">
            <strong>警告</strong>
          </span>
        </v-card-title>
        <v-card-text>
          <v-layout column>
            <v-flex xs12>
              <p class="grey--text">{{ beacons.map(b => b.name).join(', ') }}</p>
            </v-flex>
            <v-flex xs12>
              <p class="grey--text">このビーコンを登録すると使用できるアプリケーションが存在しなくなります。 利用出来るアプリケーションの組み合わせを考慮した上、登録を行なって下さい。</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="secondary" @click.stop="okAction">{{ $t('common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["dialog", "beacons"],
  methods: {
      cancelAction() {
          this.$emit("cancelAction");
      },
      okAction() {
          this.$emit("okAction");
      }
  }
};
</script>

<style>
</style>
